import { Col, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function Fouling() {
    const [crewQuality, setCrewQuality] = useState(0);
    const [isFouled, setIsFouled] = useState("");

    function rollForFouling() {
        const modifiedRoll: number = RollDice(1)[0] + crewQuality;
        if (modifiedRoll <= 3)
            setIsFouled("Fouled");
        else
            setIsFouled("Not Fouled");
    }

    return (
        <>
            <Row>
                <Col>
                    <h1>Fouling</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormLabel htmlFor="crew-quality">Crew Quality</FormLabel>
                    <FormSelect id="crew-quality" value={crewQuality} onChange={(e) => setCrewQuality(parseInt(e.target.value))}>
                        <option value={-1}>Inexperienced Crew</option>
                        <option value={0}>Experienced Crew</option>
                        <option value={1}>Veteran Crew</option>
                    </FormSelect>
                    <button className="btn btn-primary mt-3" onClick={() => rollForFouling()}>Roll for Fouling</button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h1 className="mt-5">{isFouled}</h1>
                </Col>
            </Row>
        </>
    )
}